
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DLLedger } from './ledger';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';
import { DLCompany } from './company';

const LedgerQuery = require('./gql/ledger/ledger.query.gql');
const createDLLedgerMutation = require('./gql/ledger/create-ledger.mutation.gql');
const updateDLLedgerMutation = require('./gql/ledger/update-ledger.mutation.gql');
const deleteDLLedgerMutation = require('./gql/ledger/delete-ledger.mutation.gql');

@Injectable()
export class DLLedgerService {

  constructor(private apollo: Apollo) { }

  ledger(company: string, id: string): Observable<DLCompany> {
    return this.apollo
      .query({
        query: LedgerQuery,
        variables: {
          company,
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['dlCompany'] ? new DLCompany(result.data['dlCompany']) : null));
  }

  create(company: string, ledger: DLLedger): Observable<DLLedger> {
    return this.apollo
      .mutate({
        mutation: createDLLedgerMutation,
        variables: {
          company,
          input: ledger.toCreateDLLedgerInput()
        }
      }).pipe(
      map(result => new DLLedger(result.data['createDLLedger'])));
  }

  update(company: string, id: string, ledger: DLLedger): Observable<DLLedger> {
    return this.apollo
      .mutate({
        mutation: updateDLLedgerMutation,
        variables: {
          company,
          id,
          input: ledger.toUpdateDLLedgerInput()
        }
      }).pipe(
      map(result => new DLLedger(result.data['updateDLLedger'])));
  }

  delete(company: string, id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteDLLedgerMutation,
        variables: {
          company,
          id
        }
      }).pipe(
      map(result => result.data['deleteDLLedger']));
  }
}
